/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.messages-filled\":\"Puhekuplia, joilla on hymyilevät kasvot\"}");